/**
 * Small UI icon backed by a shared SVG asset in /public/menu-icons. Referenced
 * by a typed name so the path lives in one place and the asset can be swapped
 * without touching call sites — the same approach as <Flag>, which renders
 * /public/flags via <img>.
 *
 * The source SVGs carry their own fill (chevrons gray-700, check gray-900), so
 * they render at the design color without needing `currentColor`. If a future
 * icon must follow text color, render that one via CSS `mask-image` +
 * `background-color: currentColor` instead.
 *
 * Decorative by default (`alt="" aria-hidden`): callers convey state/meaning via
 * adjacent text or aria attributes (e.g. the switcher's `aria-selected`). Size is
 * controlled by `className` (defaults to size-6).
 */
const ICON_SOURCES = {
  'chevron-up': '/menu-icons/chevron-up.svg',
  'chevron-down': '/menu-icons/chevron-down.svg',
  'chevron-left': '/menu-icons/chevron-left.svg',
  'chevron-right': '/menu-icons/chevron-right.svg',
  check: '/menu-icons/checkmark.svg',
  edit: '/menu-icons/edit.svg',
} as const

export type IconName = keyof typeof ICON_SOURCES

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <img
      src={ICON_SOURCES[name]}
      alt=""
      aria-hidden="true"
      className={`shrink-0 ${className ?? 'size-6'}`}
    />
  )
}
